import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Covid19VaccineProviderDetails from "./Covid19VaccineProviderDetails";
import Covid19VaccineProviderSlots from "./Covid19VaccineProviderSlots";

class Covid19VaccineProvider extends React.Component {
    
    render() {
        const { isVaccineSearch, selectedSlotTime, showProviderDetails, initiateRetry, providerData: prov, locationId, xid  } = this.props;       
        let defaultPhone = prov.consumerCallCenterNumber ? prov.consumerCallCenterNumber : (prov.locations && prov.locations.length > 0 ? prov.locations[0].locationPhone : "");
        
        return (
            <div className="col-12 find-care-list-item">
                <div className="row find-care-item-row">
                    <Covid19VaccineProviderDetails showProviderDetails={showProviderDetails} prov={prov} defaultPhone={defaultPhone}/>
                    <Covid19VaccineProviderSlots
                        showProviderDetails={showProviderDetails}
                        prov={prov}
                        isVaccineSearch={isVaccineSearch}
                        defaultPhone={defaultPhone}
                        selectedSlotTime={selectedSlotTime}
                        initiateRetry={initiateRetry}
                        xid={xid}
                        locationId={locationId}/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        providerSearchModel: state.providers.searchModel,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Covid19VaccineProvider));